import {USER_LOGIN, USER_LOGOUT, ADMIN_CHANGE_ARTIST, USER_GET_PLAN} from '../app/constant'

const INITIAL_STATE = {
  loginStatus: false
}

export default function userReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case USER_LOGIN:
      return {
        ...state,
        loginStatus: true,
        info: action.info
      }
    case USER_LOGOUT:
      return {
        ...state,
        loginStatus: false,
        info: null
      }
    case ADMIN_CHANGE_ARTIST:
      return {
        ...state,
        loginStatus: true,
        info: action.info
      }
    case USER_GET_PLAN:
      return {
        ...state,
        plan: action.plan
      }
    default:
      return state
  }
}
